import React from 'react';
import Card from './styled/Card';

const FAQItem = ({ question, answer, isOpen, onToggle, className = '' }) => {
  return (
    <Card className={className}>
      <button
        onClick={onToggle}
        className="w-full flex justify-between items-center p-6 text-left"
      >
        <h3 className="text-lg font-semibold text-gray-900">
          {question}
        </h3>
        <svg
          className={`w-5 h-5 text-hemp-green-600 transition-transform duration-200 ${
            isOpen ? 'rotate-180' : ''
          }`}
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
        </svg>
      </button>
      
      {isOpen && (
        <div className="px-6 pb-6 pt-0 border-t border-gray-200">
          <p className="text-gray-600 mt-4">
            {answer}
          </p>
        </div>
      )}
    </Card>
  );
};

export default FAQItem;
